'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchThreadHistoryClient = undefined;

var _noAuthApiClient = require('../../http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _wrappedPortalIdParser = require('../../utils/wrappedPortalIdParser');

var _wrappedPortalIdParser2 = _interopRequireDefault(_wrappedPortalIdParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchThreadHistoryClient = exports.fetchThreadHistoryClient = function fetchThreadHistoryClient(_ref) {
  var sessionId = _ref.sessionId,
      threadId = _ref.threadId,
      startTime = _ref.startTime;
  return _noAuthApiClient2.default.get('messages/v2/history/visitor/' + threadId, {
    query: {
      sessionId: sessionId,
      startTime: startTime,
      portalId: (0, _wrappedPortalIdParser2.default)('fetchThreadHistoryClient client')
    }
  });
};


//////////////////
// WEBPACK FOOTER
// ./js/thread-histories/clients/fetchThreadHistoryClient.js
// module id = 1073
// module chunks = 2 3